export function activityPicSwiper() {
    (function (){
        $(function (){
            const activityPicSwiper = $('.activity-pic-swiper');
            if (activityPicSwiper.length === 0) return

            activityPicSwiper.each(function (){
                const index = $(this).data('index');
                const currentComponent = `.activity-pic-swiper-${index}`;
                const currentSwiper =  $(`${currentComponent} .activity-pic-container`)
                const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
                new Swiper(currentSwiper[0], {
                    spaceBetween: clientWidth > 1024 ? 20 : 24,
                    slidesPerView: 'auto',
                    watchSlidesProgress: true,
                    watchSlidesVisibility: true,
                    observer: true, // 开启动态检查器，监测swiper和slide
                    observeParents: true, // 监测Swiper 的祖/父元素
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 1
                    },
                    allowTouchMove: true,
                    centeredSlides: false,
                    loop: false,
                    navigation: {
                        prevEl: `.activity-pic-swiper-${index} .swiper-activity-button-prev`,
                        nextEl: `.activity-pic-swiper-${index} .swiper-activity-button-next`
                    },
                    pagination: {
                        el: `${currentComponent} .activity-pagination`,
                        clickable: true,
                        bulletClass: 'slideshow-pagination-item',
                        bulletActiveClass: 'active pagination-active',
                        clickableClass: 'slideshow-pagination-clickable',
                        modifierClass: 'slideshow-pagination-',
                        renderBullet: function (index) {
                            let paginationItem = `<span class="slideshow-pagination-item" 
                                data-ga-event="activity_page_user_clicks"
                                data-ga-action="click"
                                data-ga-params-current_page=""
                                data-ga-params-module="Picture Display"
                                data-ga-params-position="Points"
                                data-tab-item >`;
                            paginationItem = (index <= 10) ? paginationItem +
                                '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
                                paginationItem;
                            paginationItem += '</span>';
                            return paginationItem;
                        },
                    },
                    on:{
                        slideChange:function(){
                            const activeIndex = this.realIndex;
                            document.querySelectorAll(`.activity-pic-swiper-${index} .slideshow-pagination-item`).forEach((el, i) => {
                                el.classList.toggle('active', i === activeIndex);
                            });
                        },
                        touchMove:function(){
                            const activeIndex = this.realIndex;
                            document.querySelectorAll(`.activity-pic-swiper-${index} .slideshow-pagination-item`).forEach((el, i) => {
                                el.classList.toggle('active', i === activeIndex);
                            });
                        },
                        transitionEnd: function() {
                            updatePaginationHighlight(this);
                        },
                    }

                })
                function updatePaginationHighlight(swiper) {
                    const activeIndex = swiper.isEnd ? swiper.pagination.bullets.length - 1 : swiper.realIndex;
                    document.querySelectorAll(`.activity-pic-swiper-${index} .slideshow-pagination-item`).forEach((el, i) => {
                        el.classList.toggle('active', i === activeIndex);
                    });
                }
                // 埋码
                $(`${currentComponent} .swiper-button-prev`).attr("data-ga-params-current_page", window.location.href);
                $(`${currentComponent} .swiper-button-next`).attr("data-ga-params-current_page", window.location.href);
                $(`${currentComponent} .swiper-slide`).attr("data-ga-params-current_page", window.location.href);


                $(`${currentComponent} .swiper-slide`).each(function() {
                    const pcImage = $(this).data('pcimage');
                    const mbImage = $(this).data('mbimage');
                    if (clientWidth>1024){
                        $(this).data('ga-params-url', pcImage);
                        $(this).attr('data-ga-params-url', pcImage);
                    }else{
                        $(this).data('ga-params-url', mbImage);
                        $(this).attr('data-ga-params-url', mbImage);
                    }

                    if(!$(this).attr("href") && $(this).attr("data-code")) {
                        const code = $(this).attr("data-code")
                        try {
                            $(this).off('click').click(function() {
                                const cb = eval( code );
                                if(cb && typeof cb === "function") {
                                    cb();
                                }
                            })
                        } catch(e) {
                            console.error(e)
                        }
                    }
                });

                $(`${currentComponent} .slideshow-pagination-item`).attr("data-ga-params-current_page", window.location.href);

            })
        })
    })();
}
